module.exports = __webpack_public_path__ + "static/media/9_I wish you enough_JP.b0e5edb0.txt";